var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "smesco-revenue"
  }, [_c('div', {
    staticClass: "flex justify-between items-center pb-6 shadow-border-b mdmax:flex-col mdmax:gap-2"
  }, [_c('div', {
    staticClass: "flex-1 flex justify-end items-center gap-2 mdmax:flex-auto mdmax:w-full"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Generate Report",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": _vm.openGenerateModal
    }
  })], 1)]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.revenues
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('div', {
          staticClass: "flex gap-2"
        }, [entry.status === 'Draft' ? _c('Button', {
          attrs: {
            "buttonText": "Approve",
            "type": "success",
            "size": "small"
          },
          on: {
            "action": function ($event) {
              return _vm.confirmApprove(entry.id);
            }
          }
        }) : _vm._e(), _c('Button', {
          attrs: {
            "buttonText": "Delete",
            "type": "delete",
            "size": "small"
          },
          on: {
            "action": function ($event) {
              return _vm.confirmDelete(entry.id);
            }
          }
        })], 1) : column.field === 'period' ? _c('span', [_vm._v(" " + _vm._s(_vm.getMonthName(entry.month)) + " " + _vm._s(entry.year) + " ")]) : column.field === 'revenue' || column.field === 'profit' ? _c('span', [_vm._v(" Rp " + _vm._s(Number(entry[column.field]).toLocaleString('id-ID')) + " ")]) : column.field === 'status' ? _c('span', [_c('span', {
          staticClass: "px-2 py-1 rounded text-xs font-medium",
          class: _vm.statusClass(entry.status)
        }, [_vm._v(" " + _vm._s(entry.status) + " ")])]) : column.field === 'report_excel_url' ? _c('span', [entry.report_excel_url ? _c('a', {
          staticClass: "text-primary-500 hover:text-primary-600 flex items-center gap-1 font-medium",
          attrs: {
            "href": entry.report_excel_url,
            "target": "_blank"
          }
        }, [_c('svg', {
          staticClass: "h-4 w-4",
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "none",
            "viewBox": "0 0 24 24",
            "stroke": "currentColor"
          }
        }, [_c('path', {
          attrs: {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            "d": "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
          }
        })]), _vm._v(" Download ")]) : _c('span', {
          staticClass: "text-neutral-400"
        }, [_vm._v("-")])]) : _c('span', [_vm._v(_vm._s(entry[column.field] !== null ? entry[column.field] : '-'))])];
      }
    }])
  }), !_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v("Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords))]) : _vm._e(), _vm.revenues && _vm.revenues.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.generateModalVisible,
      "width": "450px"
    },
    on: {
      "close": _vm.closeGenerateModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4 border-b pb-2"
  }, [_vm._v("Generate Report")]), _c('div', {
    staticClass: "grid grid-cols-1 gap-4 mb-6"
  }, [_c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Bulan")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.month,
      expression: "form.month",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "w-full border border-neutral-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });

        _vm.$set(_vm.form, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Pilih Bulan")]), _vm._l(_vm.monthNames, function (name, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index + 1
      }
    }, [_vm._v(_vm._s(name))]);
  })], 2)]), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Tahun")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.year,
      expression: "form.year",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "w-full border border-neutral-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });

        _vm.$set(_vm.form, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Pilih Tahun")]), _vm._l(_vm.yearOptions, function (y) {
    return _c('option', {
      key: y,
      domProps: {
        "value": y
      }
    }, [_vm._v(_vm._s(y))]);
  })], 2)])]), _c('div', {
    staticClass: "flex justify-end gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeGenerateModal
    }
  }, [_vm._v("Batal")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium",
    attrs: {
      "disabled": _vm.isGenerating
    },
    on: {
      "click": _vm.generateReport
    }
  }, [_vm._v(" " + _vm._s(_vm.isGenerating ? 'Proses...' : 'Generate') + " ")])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.approveModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeApproveModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v("Konfirmasi Publish")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v("Apakah Anda yakin ingin melakukan Publish data bulan ini?")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeApproveModal
    }
  }, [_vm._v("Batal")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-600 font-medium",
    on: {
      "click": _vm.submitApprove
    }
  }, [_vm._v("Publish")])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deleteModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v("Hapus Report")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v("Apakah Anda yakin ingin menghapus report data ini?")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v("Batal")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.submitDelete
    }
  }, [_vm._v("Hapus")])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }